




<div class="controller-card" id="container" style="margin: 0 auto; overflow: auto;" (scroll)="onScroll($event)">
  <div class="panel-header">
    <div class="alarm-sidepanel-heading">
      <img src="assets/img/alarm-sidebar-icon.svg" class="mx-2" />
      Action History
    </div>
    <a class="act-alarm-filter" (click)="filterPopUp()"><img src="assets/img/action-alarm-filter.svg" ></a>

  <div class="filter-panel" *ngIf="popUp">
    <div class="header">
      <span class="close" (click)="closeModalFilter()">&times;</span>
    </div>
    

    <h2>Device</h2>
    <div class="section">
      <div class="btn-group"><button class="btn device">{{this.controllerDetails.device_id}}</button></div>
    </div>

<h2>Type</h2>
<div class="section">
  <div class="btn-group" *ngFor="let filter of action_filters; let i = index">
    <button 
      class="btn"
      [class.active]="selectedActions.includes(filter.value) "
      (click)="toggleAction(filter.value)">
      <img [src]="filter.img_path" alt="icon" class="icon" />
      {{ filter.label }}
    </button>
  </div>
</div>

<div class="footer">
  <button class="btn reset" (click)="resetSelection()">Reset</button>
  <button class="btn done" (click)="submitFilters()">Done</button>
</div>
  </div>

    <div class="panel-controls">
      <span class="close-btn" (click)="modalClose()">✕</span>
    </div>
  </div>
  <div *ngIf="!spinner ;else loader"  >

<div *ngIf="isFilterSelected ;else noAlarms" >
  <div *ngFor="let group of groupedDeviceActionHistory" class="action-section" >
    <h4><span class="date-title mx-2">{{ group.label }}</span></h4>

    <div
      *ngFor="let history of group.entries"
      class="action-card rounded-2xl shadow"
    >


      <!-- <img src="assets/img/user-figure.jpg" class="user-img me-2" /> -->
       <img [src]="getUserImage(history)" class="user-img me-2" />
      <div class="action-content">
      <h4>{{ getDisplayName(history) }}</h4>



      <p *ngIf="getOperationLabel(history.device_id, history.operation_performed, history.metadata) as label">
        {{ label }}
      </p>
      </div>
      <span class="action-time">{{ getActionTimeDisplay(history.date) }}</span>
      <div class="action-icon">

<img [src]="getOperationIcon(history.operation_performed)" alt="Operation Icon">    
    
    
    </div>






<ng-container *ngIf="history.device_id === 'BackWash' && history.operation_performed === 'turn_on'">
  <div class="echodium-toggle-wrapper mt-2 flex justify-center">
    <div class="echodium-toggle cursor-pointer" (click)="toggleEchodium(history.operation_id)">
      <!-- <img src="assets/img/echodium-icon.svg" alt="echodium icon" /> -->
       <!-- <span>x</span> -->


      <mat-accordion>
          <mat-expansion-panel hideToggle>
          </mat-expansion-panel>
          <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
            <mat-expansion-panel-header>
                  <div class="custom-icon">
      <img src="assets/img/info.svg"  />
    </div>
            </mat-expansion-panel-header>
    <div  *ngIf="isEchodiumOpen(history.operation_id) " class="echodium-dropdown mt-2 p-3 bg-gray-800 rounded-lg text-sm text-white">
      <ul>
        <li *ngFor="let message of history.logger_trails">
           • {{ getSubOperationLabel(message.operation_info) }}
          
        </li>
      </ul>
    </div>

          </mat-expansion-panel>
        </mat-accordion>
    </div>
  </div>
 
</ng-container>
</div>
    </div>
  </div>
  <ng-template #noAlarms>
    <div class="no-action-history">No Action history found</div>
  </ng-template>
</div>
<ng-template #loader>
  <div class="text-center" >
    <div class="spinner-border text-primary" role="status"></div>
  </div>
</ng-template>
</div>





